import { EditBudgetButton } from './EditBudgetButton';
import { ProblemPropertyIndicator } from './ProblemPropertyIndicator';

export const DefaultDrawPanel = ({ property, styles, validateSubmission, onProblemPropertyChange }) => {
    return (
        <div style={styles.displayFlex}>
            <p>Edit Budget</p>
            <EditBudgetButton
                property={property}
                styles={styles}
                validateSubmission={validateSubmission}
            />
            <ProblemPropertyIndicator
                problemProperty={property.isProblemProperty}
                onChange={onProblemPropertyChange}
            />
        </div>
    );
};
